import { useState, useEffect, useRef } from "react";
import { StudyRecord } from "@shikaku/shared";

export function useStudyRecord(namespace: string) {
  const recordRef = useRef<StudyRecord | null>(null);
  if (!recordRef.current) {
    recordRef.current = new StudyRecord(namespace);
  }
  const record = recordRef.current;

  const [, setTick] = useState(0);

  useEffect(() => {
    record.setOnChange(() => setTick((t) => t + 1));
    return () => record.setOnChange(() => {});
  }, [record]);

  return record;
}
